import { createAction } from 'redux-actions'

export const invokeHubAction = createAction('INVOKE_HUB_ACTION')
